import { Component, Input } from "@angular/core";
import { CoreMenuItem } from "src/app/menu/core-menu";

@Component({
    selector: "app-side-menu-section",
    templateUrl: "./menu-section.component.html",
    styleUrl: "./menu-section.component.scss",
    standalone: false
})
export class SideMenuSectionComponent {
  @Input() menu: CoreMenuItem;
}
